(function() {
  'use strict';
  
  function moveExplainerToGloboGrid() {
    const explainer = document.querySelector('.category-explainer-wrapper');
    const gfControlsContainer = document.querySelector('#gf-controls-container, [id*="gf-controls"]');
    
    if (!explainer) {
      return;
    }
    
    if (!gfControlsContainer) {
      return false;
    }
    
    const gfGrid = gfControlsContainer.closest('[id*="gf-grid"]') || gfControlsContainer.parentElement;
    
    if (gfGrid) {
      const productGrid = document.querySelector('#product-grid, .product-grid');
      
      if (productGrid && gfGrid.contains(productGrid)) {
        productGrid.parentNode.insertBefore(explainer, productGrid);
      } else {
        gfControlsContainer.insertAdjacentElement('afterend', explainer);
      }
      
      return true;
    }
    
    return false;
  }
  
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', attemptPlacement);
  } else {
    attemptPlacement();
  }
  
  function attemptPlacement() {
    let attempts = 0;
    const maxAttempts = 20;
    const interval = 100;
    
    const checkAndMove = setInterval(function() {
      attempts++;
      
      if (moveExplainerToGloboGrid()) {
        clearInterval(checkAndMove);
      } else if (attempts >= maxAttempts) {
        clearInterval(checkAndMove);
      }
    }, interval);
  }
  
  document.addEventListener('globoFilterUpdate', function() {
    moveExplainerToGloboGrid();
  });
  
})();

